export const Checklist = ({ text }) => {
    return (
        <div className="flex items-center space-x-4">
            <img src="/images/proxy/socks/check.svg" className="phone:w-5 phone:h-5 w-6 h-6" alt="checklist" />
            <p className="text-md text-neutral-50 phone:text-[16px] font-normal leading-[19.3px] tracking-text-sm">{text}</p>
        </div>
    );
};